import React from "react";

export const AchatIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
     
    >
      <path d="M4 4H2V2h2a3 3 0 013 3v5a1 1 0 001 1h6.559a1 1 0 00.948-.684l.667-2A1 1 0 0015.225 7H9V5h6.225a3 3 0 012.846 3.949l-.667 2A3 3 0 0114.56 13H8a3 3 0 01-3-3V5a1 1 0 00-1-1zM9 16a2 2 0 11-4 0 2 2 0 014 0zM15 18a2 2 0 100-4 2 2 0 000 4z"></path>
    </svg>
  );
};